// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';

export class PlantSummary {
  readonly id: string;
  readonly name: string;
  readonly marketId: string;
  readonly marketName: string;
  readonly divisionId: string | null;
  readonly divisionName: string;
  readonly addressId: string;
  readonly streetAddress: string | null;
  readonly isArchived: boolean;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.marketId = data.marketId === undefined ? NIL_UUID : data.marketId;
    this.marketName = data.marketName === undefined ? '' : data.marketName;
    this.divisionId = data.divisionId === undefined ? null : data.divisionId;
    this.divisionName = data.divisionName === undefined ? '' : data.divisionName;
    this.addressId = data.addressId === undefined ? NIL_UUID : data.addressId;
    this.streetAddress = data.streetAddress === undefined ? null : data.streetAddress;
    this.isArchived = data.isArchived === undefined ? false : data.isArchived;
  }

  static zero(): PlantSummary {
    const zeroValues: ExcludeMethodsDeep<PlantSummary> = {
      id: NIL_UUID,
      name: '',
      marketId: NIL_UUID,
      marketName: '',
      divisionId: null,
      divisionName: '',
      addressId: NIL_UUID,
      streetAddress: null,
      isArchived: false,
    };
    return new PlantSummary(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type PlantSummaryWireFormat = {
  id: string;
  name: string;
  marketId: string;
  marketName: string;
  divisionId: string | null;
  divisionName: string;
  addressId: string;
  streetAddress: string | null;
  isArchived: boolean;
};

type NewPlantSummaryProps = PartialDeep<PlantSummary, { recurseIntoArrays: true }>;
export const NewPlantSummary: (props: NewPlantSummaryProps) => PlantSummary = (props) =>
  new PlantSummary(props);

type NewPlantSummaryFromWireFormatProps = PartialDeep<
  PlantSummaryWireFormat,
  { recurseIntoArrays: true }
>;
export const NewPlantSummaryFromWireFormat: (
  props: NewPlantSummaryFromWireFormatProps,
) => PlantSummary = (props) => new PlantSummary(props);
